import { render } from "./UserRoleCell.vue?vue&type=template&id=d8dfd188"
import script from "./UserRoleCell.vue?vue&type=script&lang=js"
export * from "./UserRoleCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__